export enum EnumConvenioStatus {
    Ativo,
    Inativo,
    Bloqueado
}